//Reset data
export const RESET = "PROFIL_CREATE_RESET"

//Loading
export const SET_TOGGLE_LOADING = "PROFIL_CREATE_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "PROFIL_CREATE_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "PROFIL_CREATE_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "PROFIL_CREATE_SET_MESSAGE"
export const SET_IS_SUCCESS = "PROFIL_CREATE_SET_IS_SUCCESS"
export const SET_IS_ERROR = "PROFIL_CREATE_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "PROFIL_CREATE_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "PROFIL_CREATE_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "PROFIL_CREATE_SET_HIDE_MESSAGE"

//Data
export const SET_CREATED = "PROFIL_CREATE_SET_CREATED"
export const SET_IS_CREATED = "PROFIL_CREATE_SET_IS_CREATED"
export const SET_NOT_CREATED = "PROFIL_CREATE_SET_NOT_CREATED"
export const SET_CURRENT_ITEM = "PROFIL_CREATE_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "PROFIL_CREATE_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "PROFIL_CREATE_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "PROFIL_CREATE_SET_HIDE_MODAL"


export const SET_MODAL = "PROFIL_CREATE_SET_MODAL"
export const SET_MODAL_CONTENT = "PROFIL_CREATE_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "PROFIL_CREATE_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "PROFIL_CREATE_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "PROFIL_CREATE_SET_MODAL_TYPE"